import { Component, inject, input } from '@angular/core';
import { VipLevelLabelComponent } from '../vip-level-label/vip-level-label.component';
import { NgStyle } from '@angular/common';
import { UserVipService } from '../../../core/services/user/user-vip.service';
import { TranslatePipe } from '../../../core/services/translation/translate.pipe';

@Component({
    selector: 'app-vip-progress-bar',
    imports: [
        VipLevelLabelComponent,
        NgStyle,
        TranslatePipe,
    ],
    templateUrl: './vip-progress-bar.component.html',
    styleUrl: './vip-progress-bar.component.scss'
})
export class VipProgressBarComponent {

  readonly bottomDesc = input<boolean>(true);

  public vip$: UserVipService = inject(UserVipService);

}
